module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/874e7dd6003137b73a9fbbdc7e34a27d.png";